import * as angular from "angular";
import {IController} from "angular";

export class ContractsCtrl implements IController {

  /* @ngInject */
  constructor() {
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('contracts', {
    bindings: {},
    template: require('./contracts.html').default,
    controller: ContractsCtrl
  });
